import { render, staticRenderFns } from "./SettingsDistricts.vue?vue&type=template&id=23e03fe0&scoped=true"
import script from "./SettingsDistricts.vue?vue&type=script&lang=js"
export * from "./SettingsDistricts.vue?vue&type=script&lang=js"
import style0 from "./SettingsDistricts.vue?vue&type=style&index=0&id=23e03fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e03fe0",
  null
  
)

export default component.exports